import { render } from "./ReferralForTesting.vue?vue&type=template&id=8f0cdb06"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__